import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnChanges, OnInit, Output, signal } from '@angular/core';
import { IMPORTS } from './_imports';

@Component({
    selector: 'home-item',
    templateUrl: './home-item.component.html',
    styleUrls: ['./home-item.component.scss'],
    standalone: true,
    imports: IMPORTS,
    schemas: [NO_ERRORS_SCHEMA]
})
export class HomeItemComponent implements OnInit, OnChanges {
    // #region [signals]
    $type = signal('stat');
    $statCounter = signal(null as number);
    $statLabel = signal(null as string);
    $actionTitle = signal(null as string);
    $actionDescription = signal(null as string);
    $actionIconClass = signal(null as string);
    $actionRouterLink = signal(null as any[]);
    $actionHref = signal(null as string);
    // #endregion

    // #region [Input/Output]
    @Input() _type: ('stat' | 'action');
    @Input() _statCounter: number;
    @Input() _statLabel: string;
    @Input() _actionTitle: string;
    @Input() _actionDescription: string;
    @Input() _actionIconClass: string;
    @Input() _actionRouterLink: any[];
    @Input() _actionHref: string;
    @Output() _goToEvent = new EventEmitter<any>();
    // #endregion

    constructor() { }

    /* ====================== */
    // lifecycle methods
    /* ====================== */

    ngOnInit() { }

    ngOnChanges() {
        this.$type.set(this._type);
        this.$statCounter.set(this._statCounter);
        this.$statLabel.set(this._statLabel);
        this.$actionTitle.set(this._actionTitle);
        this.$actionDescription.set(this._actionDescription);
        this.$actionIconClass.set(this._actionIconClass);
        this.$actionRouterLink.set(this._actionRouterLink);
        this.$actionHref.set(this._actionHref);
    }

    goTo() {
        this._goToEvent.emit();
    }

    // #region [===== private methods =====]
    // #endregion
}
